exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-btnGroup-ctrl[data-v-839890aa]{padding:20px 20px 10px 20px}.table-btnGroup-ctrl button[data-v-839890aa]{margin-left:0;margin-right:5px}", ""]);

// exports
